import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/eye.vue
var s = {
	name: "DtIconEye",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--eye"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Eye",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		fill: "currentColor",
		"fill-rule": "evenodd",
		"clip-rule": "evenodd"
	}, [...t[0] || (t[0] = [i("path", { d: "M1.556 6a6.694 6.694 0 0 0 .998 1.41C3.308 8.222 4.434 9 6 9c1.566 0 2.693-.778 3.446-1.59A6.693 6.693 0 0 0 10.444 6a6.693 6.693 0 0 0-.998-1.41C8.693 3.78 7.566 3 6 3c-1.566 0-2.692.779-3.446 1.59A6.694 6.694 0 0 0 1.556 6ZM11 6l.46-.197-.001-.002-.002-.003-.004-.011a3.795 3.795 0 0 0-.077-.16A7.687 7.687 0 0 0 10.18 3.91C9.308 2.97 7.934 2 6 2c-1.934 0-3.307.97-4.179 1.909A7.693 7.693 0 0 0 .624 5.626a4.515 4.515 0 0 0-.076.16l-.005.012-.001.003v.001C.54 5.802.54 5.803 1 6l-.46-.197a.5.5 0 0 0 0 .394L1 6l-.46.197.001.001v.001l.002.004.005.01a2.73 2.73 0 0 0 .076.161A7.694 7.694 0 0 0 1.821 8.09c.872.94 2.245 1.91 4.18 1.91 1.933 0 3.307-.971 4.178-1.91a7.688 7.688 0 0 0 1.197-1.716 4.737 4.737 0 0 0 .077-.16l.004-.011.002-.004v-.001L11 6Zm0 0 .46.197a.501.501 0 0 0 0-.394L11 6Z" }, null, -1), i("path", { d: "M6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM4 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=eye.js.map